export default {
	game: {
		maintenance: 'กำลังบำรุงรักษา',
		maintenance_tip: 'ไม่สามารถเข้าได้ชั่วคราว',
		no_more_data: 'ไม่มีข้อมูลเพิ่มเติม',
		search_game_name: 'ค้นหาชื่อเกม...',
		selected: 'เลือกแล้ว',
		type: 'ประเภท',
		all_types: 'ทุกประเภท',
		secondary: 'รอง',
		secondary_category: 'หมวดหมู่รอง',
		no_related_games: 'ไม่พบเกมที่เกี่ยวข้อง',
		reset_all: 'รีเซ็ตทั้งหมด',
		end_of_list: 'สิ้นสุดรายการ',
		game_details: 'รายละเอียดเกม',
		play: 'เล่น',
		bonus_cannot_wagered: 'โบนัสไม่สามารถเดิมพันได้',
		entering_game: 'กำลังเข้าสู่เกม กรุณารอสักครู่...',
		entering_game_short: 'กำลังเข้าสู่เกม...',
		game_types: 'ประเภทเกม',
		game_providers: 'ผู้ให้บริการเกม',
		sign_up: 'สมัครสมาชิก',
		search: 'ค้นหา',
		all_providers: 'ผู้ให้บริการทั้งหมด',
		loading: 'กำลังโหลด...',
		my_bet: 'การเดิมพันของฉัน'
	}
};